import { GenericFailure, GenericFailureCode, OffsetLimit } from '@playq/services-shared';
import { Left } from '@playq/irt';

import { snackbarService } from '/common/snackbarService';

export const onResponseError = (err: GenericFailure | Error) => snackbarService.genericFailure(err);

/**
 * Accepts a message and failure code and returns a default generic failure.
 * @template T - the type of a successful result.
 */
export const getDefaultGenericFailure = <T = unknown>(message: string, code: GenericFailureCode) =>
  Promise.resolve(
    new Left<GenericFailure, T>(
      new GenericFailure({
        message,
        diagnostics: undefined,
        reserved: {},
        code,
      })
    )
  );

export const calculateTotalAttachment = (
  nextOffsetLimit: OffsetLimit | undefined,
  currentLength: number,
  currentIterator: OffsetLimit,
  prefetch: number
): number => {
  if (currentLength === 0) return 0;

  const serialized = nextOffsetLimit?.serialize();

  if (!serialized) return currentLength;

  const hasMoreItems: boolean = Boolean(prefetch) && currentLength === currentIterator.limit;

  const baseCount = hasMoreItems ? serialized.offset + serialized.limit : serialized.offset;

  return baseCount + currentLength - currentIterator.limit;
};
